import React, { Component } from 'react';
import {Form, FormLayout, TextField} from "@shopify/polaris";
import './signup.css';
import ProgressBall from '../../components/progress_ball/progress_ball'

export default class SignupStepThree extends Component {
    // constructor(props) {
    //     super(props);
    // }

    handleInputChange(name, val) {
        this.props.onChange(this, name, val)
    }
    
    render() {
        return (
            <>
                <ProgressBall step='3'/>
                <h1>Add a PayPal</h1>
                <h2>Add a PayPal so you can get paid</h2>
                <Form>
                    <FormLayout>
                        <TextField type="email" label="PayPal email" value={this.props.info.paypal_address} onChange={val => this.handleInputChange('paypal_address', val) } error={this.props.info.paypal_address_error} />
                    </FormLayout>
                </Form>
            </>
        );
    }
}
